import type { CSSProperties } from "react";

const DEFAULT_DOCK_TAB_FONT_SIZE = "0.58rem";
const DEFAULT_DOCK_TAB_HEIGHT = "22px";

export function readEegDockMenuTokenStyle(
  anchor: HTMLElement | null,
): CSSProperties {
  const viewer = anchor?.closest(".eeg-viewer");
  if (!(viewer instanceof HTMLElement)) {
    return {
      ["--eeg-dock-tab-font-size" as string]: DEFAULT_DOCK_TAB_FONT_SIZE,
      ["--eeg-dock-tab-height" as string]: DEFAULT_DOCK_TAB_HEIGHT,
      fontSize: DEFAULT_DOCK_TAB_FONT_SIZE,
      fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
    };
  }

  const computed = getComputedStyle(viewer);
  const tabFontSize =
    computed.getPropertyValue("--eeg-dock-tab-font-size").trim() ||
    DEFAULT_DOCK_TAB_FONT_SIZE;
  const tabHeight =
    computed.getPropertyValue("--eeg-dock-tab-height").trim() ||
    DEFAULT_DOCK_TAB_HEIGHT;

  return {
    ["--eeg-dock-tab-font-size" as string]: tabFontSize,
    ["--eeg-dock-tab-height" as string]: tabHeight,
    fontSize: tabFontSize,
    fontFamily: computed.fontFamily,
  };
}
